
<div id="app" @click="everyClick">
  <!-- :class="theme" -->
  <keep-alive :include="keepAlive">
    <router-view />
  </keep-alive>

  <!-- <vue-confirm-dialog></vue-confirm-dialog> -->

  <TukLoader
    v-if="showTukLoader"
    @check="checkTukLoader"
    @hide="hideTukLoader"
    style="position: absolute; top: 0; z-index: 9999999"
  />

  <div v-show="showPageLoader" class="page-loader">
    <TukSpinner :size="96" />
  </div>

  <MainInit />

  <LanguageModal />
  <LoginSMSModal :verify="false" />
  <LoginModal :msg="loginModalMsg" />

  <div v-if="isReady">
    <MainDebug v-if="$store.getters.isSuperUser" />
    <IOSGPSModal2 />
    <ChromeGPSModal />
    <EditRoleModal />
    <RoleEditJSONModal />
    <RegionSelectModal />
    <SetAddressModal />
    <!-- currently geolocation prompt panel is not used, see geolocationRequestModal() -->
    <GeolocationPromptPanel />

    <DelinquencyNotice
      v-if="delinquencyNotice && showDelinquency"
      @close="showDelinquency = false"
    />
    <WarningNotice
      v-if="warningNotice && showWarningNotice"
      @close="showWarningNotice = false"
    />
    <ServiceNotice
      v-if="showServiceNotice"
      @close="showServiceNotice = false"
    />

    <!-- <ToursModal /> -->
    <!-- <InfoModal :msg="infoModalMsg" /> -->
    <!-- <UserAddressModal2 :addressType="addressType" :country="addressCountry" /> -->
    <!-- <IOSInstallModal2 /> -->
    <!-- <IOSGPSModal /> -->
  </div>

  <!-- TODO change group="passenger"-->
  <notifications group="foo" position="top center" width="100%" />
  <notifications group="eta" position="bottom center" />
  <notifications group="bottom" position="bottom center" />
  <notifications group="driver" />
</div>
